<template>
  <section class="salon" id="salon">
    <div class="jumbotron jumbotron-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-center">
            <h1>Salon</h1>
          </div>
        </div>
        <div class="row mx-auto justify-content-center">
          <div class="col-12 col-lg-3 offset-lg-1 slide-in from-left">
            <h4 class="opening-time">Öffnungszeiten</h4>
            <p>
              Montag: Geschlossen<br/>
              Dienstag - Freitag: 10:00 - 19:00 Uhr<br/>
              Samstag: 09:00 - 18:00 Uhr
            </p>
          </div>
          <div class="col-12 col-lg-3 offset-lg-1 fade-in">
            <h4 class="calendar">Termin vereinbaren</h4>
            <p>Rufen Sie an oder schreiben Sie uns:</p>
            <p>Telefon: <a href="tel:+494051906895">(040) 51 90 68 95</a><br/>
              E-Mail: &nbsp;<a href="mailto:info@haarlem-friseure.de">info@haarlem-friseure.de</a></p>
          </div>
          <div class="col-12 col-lg-3 offset-lg-1 slide-in from-right">
            <h4 class="place">Lage & Anfahrt</h4>
            <p>Besuchen Sie uns in Wandsbek, nahe des Bahnhofs Wandsbek Markt.</p>
            <p>Schloßstr. 44, 22041 Hamburg</p>
            <p>Für eine genaue Kartendarstellung klicken Sie <a @click="scrollTo('summary')">hier</a>.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Salon",
  methods: {
    scrollTo(element) {
      // get height of header
      let header = document.getElementById('navbar').offsetHeight;
      document.getElementById('nav-toggle').checked = false;

      if (this.$route.name !== 'Home') return;

      let topOfElement = document.getElementById(element).offsetTop - header;
      window.scroll({top: topOfElement, behavior: "smooth"});
    }
  },
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.salon {
  h1, h4, p {
    color: $white;
  }

  h1, h4 {
    text-transform: uppercase;
    letter-spacing: 2px;
  }

  h1 {
    padding-top: 15px;
    padding-bottom: 20px;

    @include media-breakpoint-down(md) {
      padding-bottom: 5px;
    }
  }

  h4 {
    @include media-breakpoint-down(md) {
      padding-top: 10px;
    }
  }

  a {
    color: $white;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
      text-decoration-color: white;
    }
  }

  .jumbotron {
    background: $black;
    padding-bottom: 35px;
  }

  .container-fluid {
    max-width: 95%;
  }

  .opening-time:before, .calendar:before, .place:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .opening-time:before {
    background-image: url("../../../assets/images/clock.svg");
    height: 25px;
    width: 25px;
    margin-bottom: 6px;
    margin-right: 5px;
  }

  .calendar:before {
    background-image: url("../../../assets/images/calendar.svg");
    height: 30px;
    width: 30px;
    margin-right: 5px;
  }

  .place:before {
    background-image: url("../../../assets/images/place.svg");
    height: 30px;
    width: 30px;
    margin-bottom: 5px;
    margin-right: 5px;
  }

  @include media-breakpoint-down(sm) {
    [class*="col-"] {
      margin-bottom: 30px;
    }
  }
}
</style>
